import 'jquery-ui/ui/widgets/autocomplete';

import { initSkills } from 'src/global-helpers.js';

$(function () {
  if (!$('.js-specialization-form').length) return;

  initSkills();

  const $salary = $('.js-specialization-form .text.money');

  const leadingZeros = (s) => {
    const m = /^0+/.exec(s);
    return m ? m[0].length : 0;
  };

  const fixCaretIfInsideLeadingZeros = (el, pos) => {
    const z = leadingZeros(el.value);
    if (z >= 2 && pos <= z) {
      setTimeout(() => el.setSelectionRange(0, 0), 0);
      return true;
    }
    return false;
  };

  $salary.each(function () {
    const el = this;

    el.addEventListener(
      'keydown',
      function (e) {
        const isBackspace = e.key === 'Backspace';
        const isDelete = e.key === 'Delete';

        if (isBackspace && (e.metaKey || e.ctrlKey)) {
          const start = el.selectionStart;
          const end = el.selectionEnd;
          e.preventDefault();

          const cutFrom = start !== end ? start : start;
          const newV = el.value.slice(cutFrom);
          el.value = newV;
          el.dispatchEvent(new Event('input', { bubbles: true }));

          setTimeout(() => el.setSelectionRange(0, 0), 0);
          return;
        }

        if (!(isBackspace || isDelete) || e.altKey || e.metaKey || e.ctrlKey)
          return;

        const start = el.selectionStart;
        const end = el.selectionEnd;

        if (start !== end) {
          setTimeout(() => el.setSelectionRange(start, start), 0);
          return;
        }

        const v = el.value;

        if (isBackspace && start <= 0) return;
        if (isDelete && start >= v.length) return;

        e.preventDefault();

        let newV;
        let pos;

        if (isBackspace) {
          newV = v.slice(0, start - 1) + v.slice(start);
          pos = start - 1;
        } else {
          newV = v.slice(0, start) + v.slice(start + 1);
          pos = start;
        }

        el.value = newV;
        el.dispatchEvent(new Event('input', { bubbles: true }));

        setTimeout(() => {
          if (!fixCaretIfInsideLeadingZeros(el, pos)) {
            el.setSelectionRange(pos, pos);
          }
        }, 0);
      },
      true,
    );

    el.addEventListener('blur', function () {
      const before = el.value;
      const normalized = before.replace(/^0+(?=\d)/, '0');
      if (normalized !== before) el.value = normalized;
    });
  });
});
